import { render } from "./IframesGalleryModal.vue?vue&type=template&id=392f2e06&scoped=true"
import script from "./IframesGalleryModal.vue?vue&type=script&lang=js"
export * from "./IframesGalleryModal.vue?vue&type=script&lang=js"

import "./IframesGalleryModal.vue?vue&type=style&index=0&id=392f2e06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392f2e06"]])

export default __exports__